/*
 * Action Types
 */
export enum SchemasTypes {
  LIST_SCHEMA_REQUEST = '@schemas/LIST_SCHEMA_REQUEST',
  LIST_SCHEMA_SUCCESS = '@schemas/LIST_SCHEMA_SUCCESS',
  LIST_SCHEMA_FAILURE = '@schemas/LIST_SCHEMA_FAILURE',
}

/*
 * Data types
 */
export interface SchemaInterface {
  $schema: string;
  description: string;
  type: string;
  oneOf: { $ref: string }[];
}

/*
 * State type
 */
export interface SchemasState {
  readonly schemasList: SchemaInterface;
  readonly loading: boolean;
  readonly error: boolean;
}
